module.exports = __webpack_public_path__ + "26f70c2874aece892776341cd5c55e55.svg";